"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = exports.ButtonSpace = exports.Footer = exports.Content = exports.Header = exports.Container = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Container = styled_components_1.default.div `
  padding: ${({ theme }) => theme.space.s400};
  padding-top: ${({ theme }) => theme.space.s300};
  font-weight: 500;
  max-width: 380px;
`;
exports.Header = styled_components_1.default.div `
  /* color */
  color: ${({ theme }) => theme.colors.gray.s800};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.section.title)};
`;
exports.Content = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.space.s100};

  /* color */
  color: ${({ theme }) => theme.colors.text.body};

  /* text */
  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.text)};
`;
exports.Footer = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.space.s300};
`;
exports.ButtonSpace = styled_components_1.default.div `
  margin-left: ${({ theme }) => theme.space.s200};
`;
exports.ButtonContainer = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.space.s200};
`;
